<template>
    <div class="container">
        <div v-if="!isFormVisible" class="card">
            <div class="card-header d-flex justify-content-between align-items-center ps-4 pt-3 pb-4">
                <h5><i class="fa-duotone fa-solid fa-list"></i> Lista de Usuarios</h5>
                <argon-button size="sm" color="primary" variant="gradient" @click="openCreateModal">
                    <span class="fa-solid fa-plus" />
                    Crear
                </argon-button>
            </div>
            <div class="card-body pt-0">
                <CustomFilters
:order-options="orderOptions" :items-per-page="itemsPerPage" :view-as-card="viewAsCard"
                    :show-deleted="showDeleted" @apply-filter="applyFilter" @update-items-per-page="updateItemsPerPage"
                    @update-view-as-card="updateViewAsCard" @update-show-deleted="updateShowDeleted" />
                <div v-if="loading" class="loading-indicator">
                    <p>Cargando datos...</p>
                </div>
                <div v-else>
                    <div v-if="filteredItems.length === 0" class="no-records p-5 px-4">
                        <p>No se encontraron registros. Intenta ajustar los filtros o añadir nuevos registros.</p>
                    </div>
                    <div v-else>
                        <div v-if="!viewAsCard" class="table-responsive">
                            <GenericTable
:data="filteredItems" :headers="headers" @delete-record="deleteItem"
                                @edit-record="openEditModal" @restore-record="restoreItem" />
                        </div>
                        <transition-group ref="listContainer" name="fade-move" tag="div" class="row me-2 ms-2 pt-2">
                            <template v-if="viewAsCard">
                                <AppCard
v-for="(item) in filteredItems" :key="item.id" ref="listItems" :data="item"
                                    class="fade-card" @delete-record="deleteItem" @edit-record="openEditModal"
                                    @restore-record="restoreItem" />
                            </template>
                        </transition-group>
                        <Pagination
:total-items="totalFilteredItems" :current-page="currentPage" :last-page="lastPage"
                            :items-per-page="itemsPerPage" @page-change="changePage" />
                    </div>
                </div>
            </div>
        </div>
        <ModelModal
v-if="showModal && !displayAsForm" v-model="showModal" :is-edit-mode="isEditMode"
            :resource-api="resourceApi" :entity-data="entityData" :display-as-form="displayAsForm"
            :resource-name="resourceName" @entity-updated="handleEntityUpdated">
            <template #default="{ entity, errors }">
                <div class="col-md-12 mb-3">
                    <div :class="{ 'is-invalid': errors.application_id }">
                        <MenuSelectedFull
v-model="entity.application_id"
                            label="Nombre de la instancia lógica de negocio" apiurl="applications-by-user"
                            :can-edit-and-add="false" />
                    </div>
                    <div v-if="errors.application_id" class="invalid-feedback">
                        {{ errors.application_id[0] }}
                    </div>
                </div>
                <div class="mb-3">
                    <label for="name" class="form-label">Nombre completo del usuario</label>
                    <input
id="name" v-model="entity.name" type="text" class="form-control"
                        :class="{ 'is-invalid': errors.name }">
                    <div v-if="errors.name" class="invalid-feedback">
                        {{ errors.name[0] }}
                    </div>
                </div>
                <div class="mb-3">
                    <label for="email" class="form-label">Email</label>
                    <input
id="email" v-model="entity.email" type="text" class="form-control"
                        :class="{ 'is-invalid': errors.email }">
                    <div v-if="errors.email" class="invalid-feedback">
                        {{ errors.email[0] }}
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="password" class="form-label">Contraseña</label>
                        <input
id="password" v-model="entity.password" type="password" class="form-control"
                            :class="{ 'is-invalid': errors.password }">
                        <div v-if="errors.password" class="invalid-feedback">
                            {{ errors.password[0] }}
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="password_confirmation" class="form-label">Confirmar contraseña</label>
                        <input
id="password_confirmation" v-model="entity.password_confirmation" type="password"
                            class="form-control" :class="{ 'is-invalid': errors.password_confirmation }">
                        <div v-if="errors.password_confirmation" class="invalid-feedback">
                            {{ errors.password_confirmation[0] }}
                        </div>
                    </div>
                </div>
            </template>
        </ModelModal>
        <div v-if="isFormVisible && displayAsForm" class="card">
            <div class="card-header d-flex justify-content-between align-items-center ps-4 pt-3 pb-4">
                <h5><i class="fa-duotone fa-solid fa-list"></i> {{ isEditMode ? 'Editar' : 'Crear' }} Usuario</h5>
                <argon-button size="sm" color="primary" variant="gradient" @click="closeForm">
                    <span class="fa-solid fa-arrow-left" />
                    Volver
                </argon-button>
            </div>
            <div class="card-body pt-0">
                <ModelModal
v-model="showModal" :is-edit-mode="isEditMode" :resource-api="resourceApi"
                    :entity-data="entityData" :display-as-form="displayAsForm" :keep-form-open="keepFormOpen"
                    :resource-name="resourceName" @entity-updated="handleEntityUpdated">
                    <template #default="{ entity, errors }">
                        <div class="col-md-12 mb-3">
                            <div :class="{ 'is-invalid': errors.application_id }">
                                <MenuSelectedFull
v-model="entity.application_id"
                                    label="Nombre de la instancia lógica de negocio" apiurl="applications-by-user"
                                    :can-edit-and-add="false" />
                            </div>
                            <div v-if="errors.application_id" class="invalid-feedback">
                                {{ errors.application_id[0] }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="name" class="form-label">Nombre completo del usuario</label>
                            <input
id="name" v-model="entity.name" type="text" class="form-control"
                                :class="{ 'is-invalid': errors.name }">
                            <div v-if="errors.name" class="invalid-feedback">
                                {{ errors.name[0] }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="email" class="form-label">Email</label>
                            <input
id="email" v-model="entity.email" type="text" class="form-control"
                                :class="{ 'is-invalid': errors.email }">
                            <div v-if="errors.email" class="invalid-feedback">
                                {{ errors.email[0] }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="password" class="form-label">Contraseña</label>
                            <input
id="password" v-model="entity.password" type="password" class="form-control"
                                :class="{ 'is-invalid': errors.password }">
                            <div v-if="errors.password" class="invalid-feedback">
                                {{ errors.password[0] }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="password_confirmation" class="form-label">Confirmar contraseña</label>
                            <input
id="password_confirmation" v-model="entity.password_confirmation" type="password"
                                class="form-control" :class="{ 'is-invalid': errors.password_confirmation }">
                            <div v-if="errors.password_confirmation" class="invalid-feedback">
                                {{ errors.password_confirmation[0] }}
                            </div>
                        </div>
                    </template>
                </ModelModal>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useModelActions } from '@/composables/useModelActions';
import ModelModal from '@/components/ModelModal.vue';
import CustomFilters from '@/components/CustomFilters.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import Pagination from '@/components/Pagination.vue';
import AppCard from './AppCard.vue';
import GenericTable from '@/components/GenericTable.vue';
import MenuSelectedFull from "@/components/MenuSelectedFull.vue";

const resourceApi = 'users';
const resourceName = 'Usuario';

const orderOptions = [
    { text: 'Fecha de modificación', value: 'updated_at' },
    { text: 'Fecha de creación', value: 'created_at' },
    { text: 'Nombre', value: 'name' }
];

const headers = ref([
    { text: 'Instancia', value: 'application_name' },
    { text: 'Nombre', value: 'name' },
    { text: 'Email', value: 'email' },
    { text: 'Fecha de Creación', value: 'created_at' },
    { text: 'Fecha de Modificación', value: 'updated_at' }
]);

const showModal = ref(false);
const isEditMode = ref(false);
const entityData = ref({});
const viewAsCard = ref(true);
const showDeleted = ref(false);
const loading = ref(true);
const displayAsForm = ref(false);
const keepFormOpen = ref(false);
const isFormVisible = ref(false);

const {
    openCreateModal,
    openEditModal,
    handleEntityUpdated,
    applyFilter,
    updateItemsPerPage,
    updateViewAsCard,
    updateShowDeleted,
    restoreItem,
    deleteItem,
    fetchItems,
    changePage,
    filteredItems,
    totalFilteredItems,
    currentPage,
    itemsPerPage,
    lastPage
} = useModelActions(resourceApi, {
    showModal,
    isEditMode,
    entityData,
    viewAsCard,
    showDeleted,
    displayAsForm,
    loading,
    isFormVisible,
    keepFormOpen,
    resourceName
});

watch([itemsPerPage, currentPage], ([newItemsPerPage, newPage]) => {
    if (newItemsPerPage || newPage) {
        fetchItems(newPage);
    }
});

onMounted(async () => {
    await fetchItems();
});

const closeForm = () => {
    isFormVisible.value = false;
    fetchItems(currentPage.value);
};
</script>
